<h2 mat-dialog-title>Informations sur la donnée</h2>
<mat-dialog-content>
  <p><b>Donnée :</b> {{ data.categoryName }} > {{ data.itemName }}</p>
  <p><b>Information :</b> {{ data.comment }}</p>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-flat-button mat-dialog-close cdkFocusInitial>Ok</button>
</mat-dialog-actions>
